import CommonButton from 'components/Common/CommonButton'
import DocumentPicker from 'components/Common/DocumentPicker'
import React, { useState } from 'react'
import { useLazyGetFileUrlQuery, useUploadFileMutation } from 'store/services/utility';
import LoadingOverlay from '../LoadingOverlay';
import { useFormikContext } from 'formik';

function UserDocuments({ setFieldValue, values }) {
  const { errors, submitCount } = useFormikContext();

  console.log("valuesvalues", values)

  const [insuranceRows, setInsuranceRows] = useState(
    values?.therapistDocuments?.professional_liabilities_insurances?.length
      ? values.therapistDocuments.professional_liabilities_insurances
      : []
  );

  const [uploadFile, { isLoading: fileLoading }] = useUploadFileMutation();

  const uploadAndSet = async (file, field) => {
    if (!file) {
      setFieldValue(`therapistDocuments.${field}`, null);
      return;
    }

    const result = await uploadFile({ file, acl: "public-read", fileOriginalFormat: true }).unwrap()
    if (result) {
      setFieldValue(`therapistDocuments.${field}`, result);
    }
  };

  const handleAddAnother = () => {
    const existing =
      values?.therapistDocuments?.professional_liabilities_insurances || [];

    const nextIndex = existing.length + 1;

    const updated = [
      ...existing,
      { label: `profile${nextIndex}`, file: "" },
    ];

    setInsuranceRows(updated);
    setFieldValue(
      "therapistDocuments.professional_liabilities_insurances",
      updated
    );
  };

  const removeAdditionalRow = (index) => {
    const existing =
      values?.therapistDocuments?.professional_liabilities_insurances || [];

    const updated = existing.filter((_, i) => i !== index);

    setInsuranceRows(updated);
    setFieldValue(
      "therapistDocuments.professional_liabilities_insurances",
      updated
    );
  };


  const uploadAdditionalDoc = async (file, index) => {
    if (!file) {
      removeAdditionalRow(index)
    }
    try {
      const result = await uploadFile({
        file,
        acl: "public-read",
        fileOriginalFormat: true,
      }).unwrap();

      if (!result) return;

      const existing =
        values?.therapistDocuments?.professional_liabilities_insurances || [];

      const updated = [...existing];

      updated[index] = {
        ...updated[index],
        file: result,
      };

      setFieldValue(
        "therapistDocuments.professional_liabilities_insurances",
        updated
      );
    } catch (error) {
      console.error("Additional document upload failed:", error);
    }
  };

  const handleAdditionalLabelChange = (index, value) => {
    const existing =
      values?.therapistDocuments?.professional_liabilities_insurances || [];

    const updated = [...existing];

    updated[index] = {
      ...updated[index],
      label: value,
    };

    setFieldValue(
      "therapistDocuments.professional_liabilities_insurances",
      updated
    );
  };


  return (
    <>
      {
        fileLoading && <LoadingOverlay />
      }
      <div className="pt-3 col-lg-9  pe-5">

        <div className='row align-items-center'>
          <span className='col-sm-5'></span>
          <div className='col-sm-7'>
            <h3 className='doc-title'>Upload a file</h3>
          </div>
        </div>
        <div className='d-flex flex-column gap-3'>
          <div className="">  
            <div className='row align-items-center'>
              <span className='col-sm-5 document-title'>Police Check</span>
              <div className='col-sm-7'>
                <DocumentPicker
                  value={values?.therapistDocuments?.policy_check}
                  onChange={(file) => uploadAndSet(file, "policy_check")}
                />
              </div>
            </div>
            {errors?.therapistDocuments && (
              <div className="text-danger text-end small mt-1">{errors?.therapistDocuments["policy_check"]}</div>
            )}
          </div>


          <div className='row align-items-center'>
            <span className='doc-title'>For Contractors</span>
            <span className='col-sm-5 document-title'>Business License</span>
            <div className='col-sm-7'>
              <DocumentPicker
                value={values?.therapistDocuments?.business_license}
                onChange={(file) => uploadAndSet(file, "business_license")}
              />
            </div>
          </div>
          <div className='row align-items-center'>
            <span className='doc-title'>For Professionals</span>
            <span className='col-sm-5 document-title'>College Registration</span>
            <div className='col-sm-7'>
              <DocumentPicker
                value={values?.therapistDocuments?.college_registration}
                onChange={(file) => uploadAndSet(file, "college_registration")}
              />
            </div>
          </div>

          <div className='row align-items-center'>
            <span className='col-sm-5 document-title'>Professional Liability Insurance</span>
            <div className='col-sm-7'>
              <DocumentPicker
                value={values?.therapistDocuments?.professional_liability_insurance}
                onChange={(file) =>
                  uploadAndSet(file, "professional_liability_insurance")
                }
              />
            </div>
          </div>
          <div className="d-flex flex-column gap-3">
            {insuranceRows.map((item, index) => (
              <div key={index} className="row align-items-center">
                {/* <span className="col-sm-5 document-title">
                  Professional Liability Insurance
                </span> */}
                <span className="col-sm-5 document-title">
                  <input
                    style={{ outline: "none" }}
                    type="text"
                    className="border-0 outline-0"
                    placeholder={`Field ${index + 1}`}
                    value={
                      values?.therapistDocuments?.professional_liabilities_insurances?.[index]?.label || ""
                    }
                    onChange={(e) =>
                      handleAdditionalLabelChange(index, e.target.value)
                    }
                  />
                </span>


                <div className="col-sm-7">
                  <DocumentPicker
                    value={item.file}
                    onChange={(file) => uploadAdditionalDoc(file, index)}
                  />
                </div>
              </div>
            ))}

          </div>
        </div>
        <div className='mt-4 d-flex justify-content-end'>
          <CommonButton onClick={handleAddAnother} text="Add Another" className="button-outlined" style={{ padding: "9px 20px", border: "1px solid #315D99", color: "#315D99" }} />
        </div>

      </div>
    </>
  )
}

export default UserDocuments
